import React, { Component, ErrorInfo, ReactNode } from "react";
import ErrorView from "../pages/ErrorView";

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Error caught by ErrorBoundary:", error, errorInfo);
    window.location.href = "/error";
  }

  render() {
    if (this.state.hasError) {
      return (
        <ErrorView hasHomeButton={true} message="Something went wrong" />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
